const BaseViewModel = () => this.init.apply(this, arguments)

BaseViewModel.prototype = {
  id: ko.observable(),
  course_id: ko.observable(),
  initialized: false,
  saving: ko.observable(false),
  successMessage: 'Changes saved successfully.',

  /*---------------------------------------- INITIALIZERS ----------------------------------------------------*/

  init: function(wizard, localData) {
    this.wizard = wizard;
    this.data = this.getData();
    this.localData = localData;
    this.$container = this.getContainer();

    this.course_id(this.data.course_id);
    this.id(this.data.id);

    $(document).off('pjax:start').on('pjax:start', function (evt) {
      $('.notice').remove();
    });
  },

  /*---------------------------------------- AJAX ----------------------------------------------------*/

  createOrUpdate: function(data) {
    if(this.id()) {
      return this.update(data);
    } else {
      return this.create(data);
    }
  },

  create: function(data, callback) {
    var path = Kadenze.Routes.course_sessions_path(this.course_id());
    data.lecture_medium_ids = $(".lecture_medium_ids").val();
    return this.request(data, path, 'POST', callback);
  },

  update: function(data) {
    var path = Kadenze.Routes.course_session_path(this.course_id(), this.id());
    return this.request(this.setIds(data), path, 'PATCH');
  },

  destroy: function(data) {
    var path = Kadenze.Routes.course_session_path(this.course_id(), this.id());
    return this.request(this.setIds(data), path, 'DELETE');
  },

  publish: function(data, publishCb) {
    var self = this;
    if (this.publishError)
      this.publishError.destroy();

    var publishFunc = function() {
      var path = Kadenze.Routes.publish_course_session_path(self.course_id(), self.id());
      data.lecture_medium_ids = $(".lecture_medium_ids").val();
      var req = self.request(self.setIds(data), path, 'PATCH');
      req.done(publishCb);
      return req;
    };

    if(!this.id()) {
      return this.create(data, publishFunc);
    } else {
      return publishFunc();
    }

  },

  unpublish: function(data) {
    var path = Kadenze.Routes.unpublish_course_session_path(this.course_id(), this.id());
    return this.request(this.setIds(data), path, 'PATCH');
  },

  request: function(data, route, method, callback) {
    var result,
      self = this;

    result = new Kadenze.AjaxRequest({
      url: route,
      type: method,
      dataAsJSON: false,
      timeout: 50000,
      data: { lecture: data },
      loadingIndicator: {
        container: self.getContainer()
      }
    });

    result.done($.proxy(
      function(data) {
        self.onUpdateSuccess(data);
        if (typeof callback === 'function') {
          callback.call(data);
        }
      }),
    self
    );

    result.fail($.proxy(self.onUpdateFail, self));

    return result;
  },

  onUpdateSuccess(data, textStatus, xhr) {
    if (data.session) {
      const session = JSON.parse(data.session);

      this.id(session.id);
      this.course_id(session.course_id);
      this.wizard.dispatchBindingCallbacks(session);
    }

    new Kadenze.Notice.success({ message: data.message });
  },

  onUpdateFail: function(xhr, _textStatus, _errorThrown) {
    Kadenze.UIUtil.hideLoadingIndicator($('#session'));

    var message = xhr.responseJSON.errors;

    var subject = xhr.responseJSON ?
      (xhr.responseJSON.errors.length > 1 ? 'these errors' : 'this error') :
      'any errors';

    this.publishError = new Kadenze.Notice.error(
      $.extend(
        {
          title: `Error!`,
          persistent: true
        },
        self.defaultNoticeOptions,
        { message: message }
      )
    );
  },

  /*---------------------------------------- UTILS ----------------------------------------------------*/

  getData: function() {
    return JSON.parse($('#session_json').val());
  },

  getContainer: function() {
    return $('#session');
  },

  // All methods using 'PATCH' need these attributes added
  setIds: function(data) {
    data.id = this.id();
    data.course_id = this.data.course_id;
    return data;
  },

  previousPage: function() {
    this.wizard.previousPage();
  },

  /*---------------------------------------- DATA HANDLING ----------------------------------------------------*/

  validate: function() {
    var errors = ko.validation.group(this);
    errors.showAllMessages();
    return errors();
  },

  // Return JSON
  renderData: function() {
    // Sub class may need to sanitize its own data by implementing a
    // 'prepareData' method. If that method exists, let's call it first
    if(this.prepareData) {
      this.prepareData();
    }

    // Map back to JSON
    return ko.mapping.toJS(this);
  }
};

export default BaseViewModel;
